import { Drawer, Select } from "antd";
import React, { useState, useEffect } from "react";
import { BASE_CRM_URL } from "../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Spin } from "antd";

const NewLead = ({ getLeads, onClose, show }) => {
  const navigate = useNavigate();

  const now = new Date();

  const lastcontact =
    `${now.getFullYear()}-` +
    `${String(now.getMonth() + 1).padStart(2, "0")}-` +
    `${String(now.getDate()).padStart(2, "0")} ` +
    `${String(now.getHours()).padStart(2, "0")}:` +
    `${String(now.getMinutes()).padStart(2, "0")}:` +
    `${String(now.getSeconds()).padStart(2, "0")}`;

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");

    if (!userDetails) {
      navigate("/singinThree");
    }
  }, [navigate]);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");

  const staffId = userDetails.staffid;

  const [statusData, setStatusData] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);

  const [sorceData, setSorceData] = useState([]);
  const [sourceLoading, setSourceLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const initialFormData = {
    name: "",
    company: "",
    description: "",
    country: "",
    zip: "",
    city: "",
    state: "",
    address: "",
    assigned: "",
    status: "",
    source: "",
    lastcontact: "",
    dateassigned: "",
    email: "",
    website: "",
    phonenumber: "",
    client_id: 0,
    lead_value: 0,
    active: 1,
  };

  const [formData, setFormData] = useState(initialFormData);

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);

  const getStatusDropDown = async () => {
    setStatusLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadStatus`);

      if (response.data.Status) {
        setStatusData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No status data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("status API Error:", error);
    } finally {
      setStatusLoading(false);
    }
  };

  const getSourceDropDown = async () => {
    setSourceLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadSources`);

      if (response.data.Status) {
        setSorceData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No source data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Source API Error:", error);
    } finally {
      setSourceLoading(false);
    }
  };

  const getCountries = async () => {
    setCountryLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}GetCountries`);

      if (response.data.Status) {
        setCountries(response.data.ResultData || []);
      }
    } catch (error) {
      console.error("Country API Error:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  useEffect(() => {
    getStatusDropDown();
    getSourceDropDown();
    getCountries();
  }, []);

  const statusOptions = statusData.map((status) => ({
    value: status.id,
    label: status.name,
  }));

  const sourceOptions = sorceData.map((sorce) => ({
    value: sorce.SourceId,
    label: sorce.SourceName,
  }));

  const countryOptions = countries.map((country) => ({
    value: country.country_id,
    label: country.short_name,
  }));

  const handleAddLead = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        name: formData.name,
        company: formData.company,
        description: formData.description,
        country: formData.country,
        zip: formData.zip,
        city: formData.city,
        state: formData.state,
        address: formData.address,
        assigned: staffId,
        status: 3,
        source: formData.source,
        lastcontact: lastcontact,
        dateassigned: new Date().toISOString().split("T")[0],
        email: formData.email,
        website: formData.website,
        phonenumber: formData.phonenumber,
        client_id: formData.client_id || 0,
        lead_value: Number(formData.lead_value),
        active: formData.active ? 1 : 0,
      };

      console.log("Payload :", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}leads/AddLead`,
        payload,
      );

      if (response.data.Status) {
        await Swal.fire({
          title: "Success",
          text: response.data.message || "Lead added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        await getLeads();
        onClose();

        setFormData(initialFormData);
      } else {
        Swal.fire({
          title: "Warning",
          text: response.data.Message,
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Add Lead Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  return (
    <>
      <div>
        {loading && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 1050,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <Drawer
          title="Add New Lead"
          placement="right"
          width={550}
          open={show}
          onClose={handleClose}
          destroyOnClose
          closable={false}
          styles={{
            body: {
              paddingTop: 0,
            },
          }}
          extra={
            <div className="d-flex align-items-center gap-2">
              {/* Close */}
              <button
                type="button"
                onClick={handleClose}
                disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#e40d22",
                  color: "#fff",
                  border: "none",
                }}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>

              {/* Save */}
              <button
                type="submit"
                form="addLeadForm"
                disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#07f083",
                  color: "#fff",
                  border: "none",
                }}
                title="Save"
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  <i className="fa fa-check" />
                )}
              </button>
            </div>
          }
        >
          <form id="addLeadForm" onSubmit={handleAddLead}>
            <div className="row">
              {/* Status */}
              <div className="col-6 mb-2 d-none">
                <label className="form-label">Status</label>

                <Select
                  placeholder="Status"
                  style={{
                    width: "100%",
                    height: 38,
                  }}
                  options={statusOptions}
                  value={formData.status || undefined}
                  onChange={(value) => {
                    console.log("Selected Status:", value);

                    setFormData((prev) => ({
                      ...prev,
                      status: value,
                    }));
                  }}
                  className="select2"
                  loading={statusLoading}
                />
              </div>

              {/* Company */}
              <div className="col-12 mb-2">
                <label className="form-label">
                  Company <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  required
                  placeholder="Company"
                  value={formData.company}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      company: e.target.value,
                    })
                  }
                />
              </div>

              {/* Name */}
              <div className="col-6 mb-2">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  required
                  placeholder="Name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                />
              </div>

              {/* Email */}
              <div className="col-6 mb-2">
                <label className="form-label">Email</label>

                <input
                  type="email"
                  className="form-control"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      email: e.target.value,
                    })
                  }
                />
              </div>

              {/* Phone */}
              <div className="col-6 mb-2">
                <label className="form-label">
                  Phone <span className="text-danger">*</span>
                </label>

                <input
                  type="tel"
                  className="form-control"
                  required
                  placeholder="Phone"
                  value={formData.phonenumber}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      phonenumber: e.target.value,
                    })
                  }
                />
              </div>

              {/* Source */}
              <div className="col-6 mb-2">
                <label className="form-label">Source</label>

                <Select
                  placeholder="Source"
                  style={{
                    width: "100%",
                    height: 38,
                  }}
                  options={sourceOptions}
                  value={formData.source || undefined}
                  onChange={(value) => {
                    console.log("Selected Source:", value);

                    setFormData((prev) => ({
                      ...prev,
                      source: value,
                    }));
                  }}
                  className="select2"
                  loading={sourceLoading}
                />
              </div>

              {/* Address */}
              <div className="col-12 mb-2">
                <label className="form-label">Address</label>

                <textarea
                  rows={2}
                  className="form-control"
                  placeholder="Address"
                  value={formData.address}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      address: e.target.value,
                    })
                  }
                />
              </div>

              {/* City */}
              <div className="col-6 mb-2">
                <label className="form-label">City</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="City"
                  value={formData.city}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      city: e.target.value,
                    })
                  }
                />
              </div>

              {/* State */}
              <div className="col-6 mb-2">
                <label className="form-label">State</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="State"
                  value={formData.state}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      state: e.target.value,
                    })
                  }
                />
              </div>

              {/* Country */}
              <div className="col-6 mb-2">
                <label className="form-label">Country</label>

                <Select
                  showSearch
                  placeholder="Select Country"
                  options={countryOptions}
                  value={formData.country || undefined}
                  loading={countryLoading}
                  style={{
                    width: "100%",
                    height: 38,
                  }}
                  optionFilterProp="label"
                  onChange={(value) =>
                    setFormData({
                      ...formData,
                      country: value,
                    })
                  }
                />
              </div>

              {/* Zip Code */}
              <div className="col-6 mb-2">
                <label className="form-label">Zip Code</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Zip Code"
                  value={formData.zip}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      zip: e.target.value,
                    })
                  }
                />
              </div>

              {/* Description */}
              <div className="col-12 mb-2">
                <label className="form-label">Description</label>

                <textarea
                  rows={2}
                  className="form-control"
                  placeholder="Description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      description: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </form>
        </Drawer>
      </div>
    </>
  );
};

NewLead.propTypes = {
  getLeads: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

export default NewLead;
